import React, { Component } from 'react'
import { Route, withRouter } from 'react-router'
import SwitchCSSTransitionGroup from 'switch-css-transition-group'

import Team from 'sections/team/team'
import SingleTeam from 'components/single-team/single-team'
import SinglePerson from 'components/single-person/single-person'
import SingleStakeholder from 'components/single-stakeholder/single-stakeholder'

const TeamIndex = props => {
    const {
        isGuest,
        location,
        match
    } = props

    const routes = [
        {
            route: '/teams/:team_id',
            Component: SingleTeam
        },{
            route: "/staff/:user_id",
            Component: SinglePerson
        },{
            route: '/stakeholders/:stakeholder_id',
            Component: SingleStakeholder
        },{
            route: "/guests/:user_id",
            Component: SinglePerson
        }
    ]

    return (
        <div className="page-container">
            <div className={"page-container-inner"}>
                <SwitchCSSTransitionGroup 
                    location={location} 
                    transitionName="zoom" 
                    transitionEnterTimeout={200} 
                    transitionLeaveTimeout={200}
                >
                    { routes.map(({
                        route,
                        Component
                    }) => (
                        <Route key={route} path={match.url+route} render={routeProps => (
                            <Component
                                {...routeProps}
                            />
                        )} />
                    ))}
                    <Route path={match.url} render={routeProps => (
                        <Team isGuest={isGuest} {...routeProps} />
                    )} />
                </SwitchCSSTransitionGroup>
            </div>
        </div>
    )
};

export default withRouter(TeamIndex)